import React, {Component, useLayoutEffect, useState} from 'react';
import {
   View,
   Image,
   StyleSheet,
   Dimensions,
   ImageBackground,
   Text,
   TouchableOpacity,
   NativeModules,
   SafeAreaView,
} from 'react-native';
import {
   downloadViewColor,
   white,
   getNavBarHeight,
   setWebNavTitle,
} from '../../utils/utils';
import {
   drawerListBackgroundColor,
   courseDesciptionContainerColor,
   FONT_FAMILY_REGULAR,
} from '../../utils/utils';
import {
   courseDetailLowerViewColor,
   couurseDetailButtonColor,
   courseListBGColor,
   coureTitleBGGradientColorUpper,
   coureTitleBGGradientColorLower,
   coureListGradientColorLower,
   coureListGradientColorMiddle,
   coureListGradientColorUpper,
   appBackground,
} from '../../utils/utils';
// import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {useNavigation} from '@react-navigation/native';
// import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import ModuleDetailList from './ModuleDetailList';
import ModuleDetailItem from './ModuleDetailItem';
import {PopoverLandscape as Popover} from '../../utils/popoverView';
import {CourseSupport} from '../../utils/courseSupport';
import logger from '../../utils/logger';

const {width, height} = Dimensions.get('window');

const listViewDataSoure = [
   {
      id: '1',
      title: 'Module Title Here',
      locked: 0,
   },
   {
      id: '2',
      title: 'Module Title Here',
      locked: 0,
   },
   {
      id: '3',
      title: 'Module Title Here',
      locked: 1,
   },
   {
      id: '4',
      title: 'Module Title Here',
      locked: 1,
   },
   {
      id: '5',
      title: 'Module Title Here',
      locked: 1,
   },
   {
      id: '6',
      title: 'Module Title Here',
      locked: true,
   },
   {
      id: '7',
      title: 'Module Title Here',
      locked: true,
   },
   {
      id: '8',
      title: 'Module Title Here',
      locked: true,
   },
   {
      id: '9',
      title: 'Module Title Here',
      locked: true,
   },
   {
      id: '10',
      title: 'Module Title Here',
      locked: true,
   },
];

// const handleCourseSupportAction = () => {
//    logger('handleCourseSupportAction tapped');
// };

// const handlePress = event => {
//    setAnchorView({x: event.nativeEvent.pageX, y: event.nativeEvent.pageY});
//    setPopoverVisible(true);
// };

const Header = props => (
   <View style={styles.headerContainer}>
      {/** Header title Section with gradient view, logo, title and description */}

      {/** Header Image Section TO DO provide path of coure image */}
      <View style={styles.headerImageContainer}>
         <Image
            style={styles.bgImage}
            source={require('../../assets/courseImage.png')}
         />
         {/* <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
            <Defs>
               <LinearGradient id="grad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <Stop
                     offset="0%"
                     stopColor="rgba(81, 83, 82, 0.5)"
                     stopOpacity="0"
                  />
                  <Stop offset="100%" stopColor="#141414" stopOpacity="1" />
               </LinearGradient>
            </Defs>
            <Rect width="100%" height="100%" fill="url(#grad)" />
         </Svg> */}
         <UISvg
            height="100%"
            width="100%"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
            offset={['0%', '100%']}
            stopColor={['rgba(81, 83, 82, 0.5)', '#141414']}
         />
         <Text style={styles.moduleTitle}>
            {'Supervisor Health and Safety Awareness'}
         </Text>
         <Text style={styles.moduleInfo}>
            {
               'This program covers health and safety for managers and frontline supervisors.'
            }
         </Text>
         {/** Header module icons sections */}
         <View style={{flexDirection: 'row', marginLeft: 16, marginTop: 10}}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <Image
                  source={require('../../assets/course_hightlight_24.png')}
                  style={styles.moduleIcon}
               />
               <Text style={styles.moduleDescription}>{'3 Modules'}</Text>
            </View>

            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <Image
                  source={require('../../assets/Timer.png')}
                  style={styles.moduleIcon}
               />
               <Text style={styles.moduleDescription}>{'1 Hour'}</Text>
            </View>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <Image
                  source={require('../../assets/Check.png')}
                  style={styles.moduleIcon}
               />
               <Text style={styles.moduleDescription}>{'1 Year'}</Text>
            </View>
         </View>
      </View>

      {/** Header description Section */}
      <View style={styles.headerDescriptionContainer}>
         {/** Title and progress section */}
         <View
            style={{
               flex: 1,
               flexDirection: 'row',
               justifyContent: 'space-between',
               width: width,
               height: height * 0.1 * 0.8,
            }}>
            <View style={{width: width * 0.6, marginTop: 10}}>
               <Text style={styles.availableModuleTitle}>
                  {'Available Modules'}
               </Text>
               <Text style={styles.moduleAvailableDescription}>
                  {
                     'Please select a module to begin or continue with your training'
                  }
               </Text>
            </View>

            <View style={{width: width * 0.3 - 20, marginTop: 10}}>
               <Text style={styles.moduleCompletedCount}>{'0/11'}</Text>
               <Text style={styles.moduleCompleted}>{'Module Completed'}</Text>
            </View>

            <View
               style={{
                  width: width * 0.1,
                  justifyContent: 'center',
                  marginHorizontal: 10,
               }}>
               {/* <AnimatedCircularProgress
                  size={40}
                  width={3}
                  fill={'70'}
                  rotation={0}
                  tintColor="#26E555"
                  backgroundColor="#1C222B">
                  {fill => (
                     <View
                        style={{
                           width: '100%',
                           height: '100%',
                           justifyContent: 'center',
                           alignItems: 'center',
                           backgroundColor: '#1C222B',
                           opacity: 0.6,
                        }}>
                        <Image
                           source={require('../../assets/course_hightlight_24.png')}
                           style={{width: 17, height: 18}}
                        />
                     </View>
                  )}
               </AnimatedCircularProgress> */}
               <UICircularProgress
                  size={40}
                  width={3}
                  fill={70}
                  rotation={0}
                  tintColor="#26E555"
                  backgroundColor="#1C222B"
                  img={require('../../assets/course_hightlight_24.png')}
                  imgWidth={17}
                  imgHeight={18}
               />
            </View>
         </View>
         <View
            style={{
               width: width * 0.3 - 16 * 2,
               height: 4,
               backgroundColor: '#26E555',
               borderRadius: 10,
               justifyContent: 'center',
               marginHorizontal: 16,
               marginVertical: 5,
            }}
         />
      </View>
   </View>
);

const ModuleDetails = props => {
   const navigation = useNavigation();
   const [popoverVisible, setPopoverVisible] = useState(false);
   const [anchorView, setAnchorView] = useState({x: 0, y: 100});

   useLayoutEffect(() => {
      props.navigation.setOptions({
         headerTitle: 'Course',
      });
      setWebNavTitle(navigation, 'Course');
   }, [props.navigation]);
   return (
      <SafeAreaView style={styles.container}>
         {/* <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
            <Defs>
               <LinearGradient id="grad" x1="0%" y1="100%" x2="0%" y2="100%">
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorLower}
                     stopOpacity="1"
                  />
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorMiddle}
                     stopOpacity="1"
                  />
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorUpper}
                     stopOpacity="1"
                  />
               </LinearGradient>
            </Defs>
            <Rect width="100%" height="100%" fill="url(#grad)" />
         </Svg> */}
         <UISvg
            height="100%"
            width="100%"
            x1="0%"
            y1="100%"
            x2="0%"
            y2="100%"
            offset={['100%', '100%', '100%']}
            stopColor={[
               coureListGradientColorLower,
               coureListGradientColorMiddle,
               coureListGradientColorUpper,
            ]}
            stopOpacity={['1', '1', '1']}
         />
         {/** Back button and navigatin title  */}
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               height: getNavBarHeight(),
            }}>
            <TouchableOpacity
               style={{padding: 10, marginTop: 0}}
               onPress={() => {
                  props.navigation.goBack();
               }}>
               <Image
                  source={require('../../assets/back_arrow.png')}
                  style={{width: 16, height: 16}}
               />
            </TouchableOpacity>
            <Text
               style={{
                  fontSize: 16,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
                  color: 'white',
                  marginStart: 21,
                  marginTop: 0,
               }}>
               {'Course Overview'}
            </Text>
         </View>

         <ModuleDetailList
            ItemSeparatorComponent={props => {
               // here you can access the trailingItem with props.trailingItem
               return <View style={{height: 8}} />;
            }}
            ListHeaderComponent={<Header onExitClick={props.onExitClick} />}
            data={listViewDataSoure}
            renderItem={({
               item,
               iconTintColor,
               titleColor,
               isSelected,
               index,
            }) => (
               <ModuleDetailItem
                  icon={item.icon}
                  title={item.title}
                  iconTintColor={iconTintColor}
                  titleColor={titleColor}
                  isSelected={isSelected}
                  index={index}
                  locked={item.locked}
               />
            )}
            keyExtractor={item => item.id}
            contentContainerStyle={{flexGrow: 1}}
            onSelect={item => {
               logger('pressed course ID: item.id');
               props.onRowSelected(item.id);
            }}
         />

         <View style={styles.lowerView}>
            <TouchableOpacity
               style={styles.courseSupportButtonView}
               onPress={event => {
                  logger('show popover');
                  setAnchorView({x: 16, y: event.nativeEvent.pageY - 280});
                  setPopoverVisible(true);
               }}>
               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'center',
                     alignItems: 'center',
                  }}>
                  <Image source={require('../../assets/supportIcon.png')} />
                  <Text style={styles.buttonTitle}>{'Course Support'}</Text>
               </View>
            </TouchableOpacity>
         </View>
         <Popover
            visible={popoverVisible}
            anchorView={anchorView}
            onclose={() => {
               setPopoverVisible(false);
            }}
            content={<CourseSupport />}
         />
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
   },
   headerTopBackground: {
      backgroundColor: drawerListBackgroundColor,
      paddingHorizontal: 16,
      paddingVertical: 16,
      flexDirection: 'row',
      alignItems: 'center',
   },
   upperView: {
      width: '100%',
      height: '50%',
      backgroundColor: downloadViewColor,
      justifyContent: 'center',
      alignItems: 'center',
   },
   headerContainer: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
   },
   headerBtnContainer: {
      width: '100%',
      height: 48,
      backgroundColor: drawerListBackgroundColor,
   },
   buttonView: {
      backgroundColor: couurseDetailButtonColor,
      minHeight: 32,
      borderRadius: 6,
      justifyContent: 'center',
   },
   buttonTitle: {
      color: 'white',
      fontSize: 12,
      fontWeight: '700',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
   headerTitleContainer: {
      width: '100%',
      height: height * 0.12,
      backgroundColor: '#003DA5',
   },
   headerLogo: {
      width: 119,
      height: 16,
      marginLeft: 16,
      marginVertical: 15,
   },
   courseTitle: {
      color: 'white',
      fontSize: 20,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 16,
   },
   courseDescription: {
      color: 'white',
      fontSize: 12,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 16,
      opacity: 0.6,
      marginTop: 5,
   },
   headerDescriptionContainer: {
      width: '100%',
      height: height * 0.1 + 10,
      backgroundColor: courseDesciptionContainerColor,
   },
   moduleDescription: {
      fontSize: 8,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 5,
      marginRight: 8,
   },
   moduleInfo: {
      fontSize: 9,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
      opacity: 0.6,
   },
   moduleIcon: {
      width: 10,
      height: 10,
      resizeMode: 'contain',
   },
   availableModuleTitle: {
      fontSize: 16,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
   },
   moduleTitle: {
      fontSize: 24,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
      marginTop: height * 0.1 * 0.8,
   },
   moduleAvailableDescription: {
      fontSize: 10,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
      marginTop: 5,
   },
   moduleCompletedCount: {
      fontSize: 24,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
      marginTop: 5,
      textAlign: 'center',
   },
   moduleCompleted: {
      fontSize: 8,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 16,
      marginTop: 3,
      textAlign: 'center',
   },
   headerImageContainer: {
      width: width,
      height: height * 0.2 + 10,
   },
   bgImage: {
      position: 'absolute',
      resizeMode: 'cover',
      width: '100%',
      height: '100%',
   },
   lowerView: {
      height: height * 0.08,
      backgroundColor: courseDetailLowerViewColor,
      justifyContent: 'center',
      alignItems: 'center',
   },
   courseSupportButtonView: {
      backgroundColor: couurseDetailButtonColor,
      minHeight: 40,
      borderRadius: 6,
      justifyContent: 'center',
      marginHorizontal: 16,
      width: width - 32,
   },
});

export default ModuleDetails;
